export let ActualizarArticuloRouteComponent = {
    selector: 'actualizarArticulosRoute',
    template: require('./actualizar-articulo.html'),
    controller: class {

        /*@ngInject*/
        constructor(ArticuloService, $location, ToasterService){
            Object.assign(this, {ArticuloService, $location, ToasterService});
            this.listaArticulos = '';
            this.actualizandoArticulos = false;
        }

        actualizarActiculos(){
            if (this.listaArticulos) {
                this.actualizandoArticulos = true;
                this.ArticuloService.actualizarArticulos({data: this.listaArticulos})
                    .then(() => {
                        this.actualizandoArticulos = false;
                        this.ToasterService.popUp('success','Articulos', 'Se han actualizado con éxito.');
                        this.$location.path('/');
                    })
            } else {
                this.ToasterService.popUp('info','Informacion', 'Agregue un nuevo listado.');
            }
        }
        ocultarPrecios(){
            this.actualizandoArticulos = true;
            this.ArticuloService.ocultarPrecios()
                .then(() => {
                    this.actualizandoArticulos = false;
                    this.ToasterService.popUp('success','Articulos', 'Se han actualizado con éxito.');
                    this.$location.path('/');
                });
        }
        mostrarPrecios(){
            this.actualizandoArticulos = true;
            this.ArticuloService.mostrarPrecios()
                .then(() => {
                    this.actualizandoArticulos = false;
                    this.ToasterService.popUp('success','Articulos', 'Se han actualizado con éxito.');
                    this.$location.path('/');
                });
        }
    }
};



// WEBPACK FOOTER //
// ./client/app/articulo-route/actualizar/actualizar-articulo.component.js